import HsaSuccessDollar from 'assets/svgs/hsaSuccessDollar';

import { useHsaSuccessAutoRedirect } from './hsaSuccessNavigation';
import {
  HsaSuccessContent,
  HsaSuccessDollarBills,
  HsaSuccessDollarBillsSrc,
  HsaSuccessIconInnerCircle,
  HsaSuccessIconOuterRing,
  HsaSuccessRoot,
  HsaSuccessSubtitle,
  HsaSuccessTitle,
} from './hsaSuccessPage.styles';

const HsaSuccessPage = () => {
  useHsaSuccessAutoRedirect();

  return (
    <HsaSuccessRoot data-testid="hsa-success-page">
      <HsaSuccessDollarBills
        src={HsaSuccessDollarBillsSrc}
        alt=""
        aria-hidden
        data-testid="hsa-success-dollar-bills"
      />
      <HsaSuccessContent>
        <HsaSuccessIconOuterRing data-testid="hsa-success-icon">
          <HsaSuccessIconInnerCircle>
            <HsaSuccessDollar aria-hidden />
          </HsaSuccessIconInnerCircle>
        </HsaSuccessIconOuterRing>
        <HsaSuccessTitle variant="h2_Bold">Woohoo!</HsaSuccessTitle>
        <HsaSuccessSubtitle variant="body2_Regular">
          Your HSA Payday is on the way.
        </HsaSuccessSubtitle>
      </HsaSuccessContent>
    </HsaSuccessRoot>
  );
};

export default HsaSuccessPage;
